import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "@i18n";
import PriceSection from "./sections/PriceSection";
import Tabs from "@componentsShared/Tailwind/Tabs/Tabs";
import InspectionReport from "./sections/InspectionReport";
import CarInformation from "./sections/CarInformation";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
import { Icon } from "@syarahtech/ui";
import useHelpers from "@hooks/useHelpers";
import useSticky from "@hooks/useSticky";
import { twMerge } from "tailwind-merge";
import BackButton from "@/components/UiKit/Buttons/BackButton/BackButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api__getCompareResult } from "@/apis/compare/compare";
import Loader from "@componentsShared/Loader/Loader";
import useBoolean from "@hooks/useBoolean";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useSubmissionSource from "@hooks/useSubmissionSource";
var CarComparison = function CarComparison() {
  var _queryParams$get, _data$sections, _data$status2, _data$status3, _data$id2, _data$id3, _data$status4, _data$title2, _data$status5, _data$id4, _data$status6, _data$title3, _data$id5, _data$status7, _data$image, _data$id6, _data$id7, _data$status8, _data$image2, _data$id8, _data$status9, _data$status0;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useCarCompareContext = useCarCompareContext(),
    removeCar = _useCarCompareContext.removeCar,
    bigData = _useCarCompareContext.bigData,
    addCar = _useCarCompareContext.addCar,
    updateCarList = _useCarCompareContext.updateCarList;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var navigate = useNavigate();
  var sectionRef = useRef(null);
  var _useState = useState(false),
    isSticky = _useState[0],
    setIsSticky = _useState[1];
  var stickyRef = useRef(null);
  var isComponentSticky = useSticky(stickyRef);
  var tabsSticky = useRef(null);
  var isTabsSticky = useSticky(tabsSticky);
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn,
    user = _useSession.user;
  var location = useLocation();
  var queryParams = new URLSearchParams(location.search);
  var compareCars = queryParams === null || queryParams === void 0 ? void 0 : (_queryParams$get = queryParams.get('compare_cars')) === null || _queryParams$get === void 0 ? void 0 : _queryParams$get.split(",");
  var _useState2 = useState({}),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(false),
    sectionsReady = _useState3[0],
    setSectionsReady = _useState3[1];
  var sectionRefs = useRef(new Map());
  var loading = useBoolean(true);
  var _useSubmissionSource = useSubmissionSource(),
    setSubmissionSource = _useSubmissionSource.setSubmissionSource;
  useEffect(function () {
    loading.setTrue();
    if (!compareCars || compareCars.length === 0 || compareCars.every(function (id) {
      return !id;
    })) {
      setSectionsReady(true);
      setData([]);
      loading.setFalse();
      return;
    }
    api__getCompareResult(compareCars).then(function (res) {
      var _res$id;
      setData(res);
      var cars = res === null || res === void 0 ? void 0 : (_res$id = res.id) === null || _res$id === void 0 ? void 0 : _res$id.map(function (id, index) {
        var _res$title, _res$image, _res$g4Data, _res$status;
        return {
          id: id,
          title: res === null || res === void 0 ? void 0 : (_res$title = res.title) === null || _res$title === void 0 ? void 0 : _res$title[index],
          title_ar: res === null || res === void 0 ? void 0 : res.title_ar[index],
          title_en: res === null || res === void 0 ? void 0 : res.title_en[index],
          image_url: res === null || res === void 0 ? void 0 : (_res$image = res.image) === null || _res$image === void 0 ? void 0 : _res$image[index],
          g4_data_layer: res === null || res === void 0 ? void 0 : (_res$g4Data = res.g4Data) === null || _res$g4Data === void 0 ? void 0 : _res$g4Data[index],
          is_booked: (res === null || res === void 0 ? void 0 : (_res$status = res.status) === null || _res$status === void 0 ? void 0 : _res$status[index]) === "reserved",
          product_url: createUrl("/cardetail/".concat(id))
        };
      });
      updateCarList(cars);
      setSectionsReady(true);
      loading.setFalse();
    });
  }, [location]);
  var bothSold = useMemo(function () {
    var _data$status;
    return data === null || data === void 0 ? void 0 : (_data$status = data.status) === null || _data$status === void 0 ? void 0 : _data$status.every(function (status) {
      return status === "sold";
    });
  }, [data]);
  var tabs = (data === null || data === void 0 ? void 0 : (_data$sections = data.sections) === null || _data$sections === void 0 ? void 0 : _data$sections.map(function (section) {
    var sectionRef = function sectionRef(el) {
      if (el) sectionRefs.current.set(section.key, el);
    };
    switch (section.key) {
      case "car_price":
        return {
          label: section === null || section === void 0 ? void 0 : section.title,
          content: /*#__PURE__*/React.createElement(PriceSection, {
            details: section === null || section === void 0 ? void 0 : section.details,
            title: section === null || section === void 0 ? void 0 : section.title,
            carStatus: data === null || data === void 0 ? void 0 : data.status
          }),
          id: "car_price"
        };
      case "inspection":
        return {
          label: section === null || section === void 0 ? void 0 : section.title,
          content: /*#__PURE__*/React.createElement(InspectionReport, {
            details: section === null || section === void 0 ? void 0 : section.details,
            title: section === null || section === void 0 ? void 0 : section.title,
            ref: sectionRef
          }),
          id: "inspection_report"
        };
      case "car_info":
        return {
          label: section === null || section === void 0 ? void 0 : section.title,
          content: /*#__PURE__*/React.createElement(CarInformation, {
            details: section === null || section === void 0 ? void 0 : section.details,
            title: section === null || section === void 0 ? void 0 : section.title
          }),
          id: "car_info"
        };
      default:
        return {
          label: "default",
          content: /*#__PURE__*/React.createElement("div", null, "default")
        };
    }
  })) || [];
  useEffect(function () {
    if (!sectionsReady) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setIsSticky(true);
        }
      });
    }, {
      threshold: 0.75
    });
    sectionRefs.current.forEach(function (ref) {
      if (ref) observer.observe(ref);
    });
    return function () {
      sectionRefs.current.forEach(function (ref) {
        if (ref) observer.unobserve(ref);
      });
    };
  }, [sectionsReady]);
  var handeAddCar = function handeAddCar() {
    navigateTo(createUrl((bigData === null || bigData === void 0 ? void 0 : bigData.referral_location) || "/filters"));
  };
  var handleRemoveCar = function handleRemoveCar(imageId) {
    var _params$get;
    removeCar(imageId);
    var params = new URLSearchParams(location.search);
    var compareCars = ((_params$get = params.get("compare_cars")) === null || _params$get === void 0 ? void 0 : _params$get.split(",")) || [];
    var updatedCompareCars = compareCars.filter(function (id) {
      return id !== imageId.toString();
    });
    if ((updatedCompareCars === null || updatedCompareCars === void 0 ? void 0 : updatedCompareCars.length) > 0) {
      params.set("compare_cars", updatedCompareCars.join(","));
    } else {
      params["delete"]("compare_cars");
    }
    navigateTo("".concat(location.pathname, "?").concat(params.toString()));
  };
  var handleTabClick = function handleTabClick(id) {
    var _data$g4Data;
    if ((data === null || data === void 0 ? void 0 : (_data$g4Data = data.g4Data) === null || _data$g4Data === void 0 ? void 0 : _data$g4Data.length) > 0) {
      var _data$g4Data2, _data$g4Data2$, _data$g4Data3, _data$g4Data3$, _data$g4Data4, _data$g4Data4$, _data$g4Data5, _data$g4Data5$, _data$g4Data6, _data$g4Data6$, _data$g4Data7, _data$g4Data7$, _data$g4Data8, _data$g4Data8$, _data$g4Data9, _data$g4Data9$, _data$g4Data0, _data$g4Data0$, _data$g4Data1, _data$g4Data1$;
      var post1Data = {
        post_1_id: (data === null || data === void 0 ? void 0 : (_data$g4Data2 = data.g4Data) === null || _data$g4Data2 === void 0 ? void 0 : (_data$g4Data2$ = _data$g4Data2[0]) === null || _data$g4Data2$ === void 0 ? void 0 : _data$g4Data2$.post_id) || "",
        post_1_make: (data === null || data === void 0 ? void 0 : (_data$g4Data3 = data.g4Data) === null || _data$g4Data3 === void 0 ? void 0 : (_data$g4Data3$ = _data$g4Data3[0]) === null || _data$g4Data3$ === void 0 ? void 0 : _data$g4Data3$.post_make) || "",
        post_1_model: (data === null || data === void 0 ? void 0 : (_data$g4Data4 = data.g4Data) === null || _data$g4Data4 === void 0 ? void 0 : (_data$g4Data4$ = _data$g4Data4[0]) === null || _data$g4Data4$ === void 0 ? void 0 : _data$g4Data4$.post_model) || "",
        post_1_year: (data === null || data === void 0 ? void 0 : (_data$g4Data5 = data.g4Data) === null || _data$g4Data5 === void 0 ? void 0 : (_data$g4Data5$ = _data$g4Data5[0]) === null || _data$g4Data5$ === void 0 ? void 0 : _data$g4Data5$.post_year) || "",
        post_1_condition: (data === null || data === void 0 ? void 0 : (_data$g4Data6 = data.g4Data) === null || _data$g4Data6 === void 0 ? void 0 : (_data$g4Data6$ = _data$g4Data6[0]) === null || _data$g4Data6$ === void 0 ? void 0 : _data$g4Data6$.post_condition) || ""
      };
      var post2Data = {
        post_2_id: (data === null || data === void 0 ? void 0 : (_data$g4Data7 = data.g4Data) === null || _data$g4Data7 === void 0 ? void 0 : (_data$g4Data7$ = _data$g4Data7[1]) === null || _data$g4Data7$ === void 0 ? void 0 : _data$g4Data7$.post_id) || "",
        post_2_make: (data === null || data === void 0 ? void 0 : (_data$g4Data8 = data.g4Data) === null || _data$g4Data8 === void 0 ? void 0 : (_data$g4Data8$ = _data$g4Data8[1]) === null || _data$g4Data8$ === void 0 ? void 0 : _data$g4Data8$.post_make) || "",
        post_2_model: (data === null || data === void 0 ? void 0 : (_data$g4Data9 = data.g4Data) === null || _data$g4Data9 === void 0 ? void 0 : (_data$g4Data9$ = _data$g4Data9[1]) === null || _data$g4Data9$ === void 0 ? void 0 : _data$g4Data9$.post_model) || "",
        post_2_year: (data === null || data === void 0 ? void 0 : (_data$g4Data0 = data.g4Data) === null || _data$g4Data0 === void 0 ? void 0 : (_data$g4Data0$ = _data$g4Data0[1]) === null || _data$g4Data0$ === void 0 ? void 0 : _data$g4Data0$.post_year) || "",
        post_2_condition: (data === null || data === void 0 ? void 0 : (_data$g4Data1 = data.g4Data) === null || _data$g4Data1 === void 0 ? void 0 : (_data$g4Data1$ = _data$g4Data1[1]) === null || _data$g4Data1$ === void 0 ? void 0 : _data$g4Data1$.post_condition) || ""
      };
      trackEvents("comparison_tab_view", _objectSpread(_objectSpread({
        tab_name: id
      }, post1Data), post2Data));
    }
  };
  var renderImage = function renderImage(url, imageId, index) {
    var _data$title;
    return /*#__PURE__*/React.createElement("div", {
      id: "compare-car-image-wrapper-".concat(index + 1),
      className: twMerge("w-1/2 rounded border border-neutral-60 relative flex h-[130px] md:h-[265px]", (data === null || data === void 0 ? void 0 : data.status[index]) === "reserved" ? 'after:absolute after:bg-[#979797b3] after:block after:w-full after:h-full rounded-inherit' : '')
    }, /*#__PURE__*/React.createElement("div", {
      id: "compare-close-icon-".concat(index + 1),
      className: "rounded-full p-[3px] flex items-center justify-center bg-white md:bg-gray-alice w-6 h-6 absolute top-[-12px] left-[-2px] z-10",
      role: "button",
      tabIndex: 0,
      onClick: function onClick() {
        return handleRemoveCar(imageId);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          e.currentTarget.click();
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full h-full rounded-full border-2 border-solid border-gray-text  flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--close-rounded",
      className: "text-[#484848]"
    }))), /*#__PURE__*/React.createElement("img", {
      id: "compare-car-image-".concat(index + 1),
      className: "rounded-inherit w-full",
      src: url,
      alt: (data === null || data === void 0 ? void 0 : (_data$title = data.title) === null || _data$title === void 0 ? void 0 : _data$title[index]) || "Car photo"
    }), (data === null || data === void 0 ? void 0 : data.status[index]) === "reserved" && /*#__PURE__*/React.createElement("span", {
      id: "compare-car-reserved-".concat(index + 1),
      className: "text-white font-bold text-md absolute top-[50%] left-[50%] z-10 transform translate-x-[-50%] translate-y-[-50%]"
    }, t("reserved", {
      ns: "web_common"
    })));
  };
  function handleReserveCar(id) {
    var _data$g4Data10, _data$g4Data10$id, _data$g4Data11, _data$g4Data11$id, _data$g4Data12, _data$g4Data12$id, _data$g4Data13, _data$g4Data13$id, _data$id;
    trackEvents("comparison_book_car", {
      post_id: data === null || data === void 0 ? void 0 : (_data$g4Data10 = data.g4Data) === null || _data$g4Data10 === void 0 ? void 0 : (_data$g4Data10$id = _data$g4Data10[id]) === null || _data$g4Data10$id === void 0 ? void 0 : _data$g4Data10$id.post_id,
      post_make: data === null || data === void 0 ? void 0 : (_data$g4Data11 = data.g4Data) === null || _data$g4Data11 === void 0 ? void 0 : (_data$g4Data11$id = _data$g4Data11[id]) === null || _data$g4Data11$id === void 0 ? void 0 : _data$g4Data11$id.post_make,
      post_model: data === null || data === void 0 ? void 0 : (_data$g4Data12 = data.g4Data) === null || _data$g4Data12 === void 0 ? void 0 : (_data$g4Data12$id = _data$g4Data12[id]) === null || _data$g4Data12$id === void 0 ? void 0 : _data$g4Data12$id.post_model,
      post_year: data === null || data === void 0 ? void 0 : (_data$g4Data13 = data.g4Data) === null || _data$g4Data13 === void 0 ? void 0 : (_data$g4Data13$id = _data$g4Data13[id]) === null || _data$g4Data13$id === void 0 ? void 0 : _data$g4Data13$id.post_year
    });
    setSubmissionSource('car_comparison');
    navigateTo(createUrl("/pre-checkout/".concat(data === null || data === void 0 ? void 0 : (_data$id = data.id) === null || _data$id === void 0 ? void 0 : _data$id[id], "#referral_location=car_comparison")));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, loading.value && /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: true,
    hideAppBanner: true,
    mobileNoLogo: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement("div", {
      id: "compare-mobile-header",
      className: "flex items-center px-4 py-5 bg-white border-b border-b-gray-gainsboro border-solid"
    }, /*#__PURE__*/React.createElement("div", {
      id: "compare-remove-btn",
      className: "en:transform en:rotate-180",
      onClick: function onClick() {
        if (bigData !== null && bigData !== void 0 && bigData.referral_location) {
          navigateTo(createUrl(bigData === null || bigData === void 0 ? void 0 : bigData.referral_location));
        } else {
          navigate(-1);
        }
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--arrow-forward-ios-rounded",
      width: 4,
      height: 4,
      className: "text-[#3c56d4]"
    })), /*#__PURE__*/React.createElement("div", {
      id: "compare-mobile-header-title",
      className: "text-sm flex items-center text-primary font-bold m-auto"
    }, t("car_comparison", {
      ns: "web_common"
    })), /*#__PURE__*/React.createElement("div", {
      className: "w-4 h-4"
    }))
  }, /*#__PURE__*/React.createElement("div", {
    id: "compare-desktop-header",
    className: "hidden md:block container pt-10 pb-6"
  }, /*#__PURE__*/React.createElement(BackButton, {
    id: "compare-back-btn",
    className: twMerge("mb-4", "hidden md:block"),
    onClick: function onClick() {
      if (bigData !== null && bigData !== void 0 && bigData.referral_location) {
        navigateTo(createUrl(bigData === null || bigData === void 0 ? void 0 : bigData.referral_location));
      } else {
        navigate(-1);
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    id: "compare-back-text",
    className: "text-gray-causeway text-sm"
  }, t("back", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "compare-car-title",
    className: "text-primary font-bold text-3xl"
  }, t("car_comparison", {
    ns: "web_common"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "pb-[80px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-gray-alice"
  }, bothSold ? /*#__PURE__*/React.createElement("div", {
    id: "compare-sold-banner-container",
    className: "container pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:pb-8 mb-7 mt-4 md:mt-6"
  }, /*#__PURE__*/React.createElement("div", {
    id: "compare-sold-banner",
    className: "w-full bg-primary p-2 rounded md:py-3 md:px-4 md:mb-0"
  }, /*#__PURE__*/React.createElement("span", {
    id: "compare-sold-text",
    className: "text-white font-bold text-sm"
  }, t("cars_chose_compare_sold", {
    ns: "web_common"
  }))))) : ((data === null || data === void 0 ? void 0 : (_data$status2 = data.status) === null || _data$status2 === void 0 ? void 0 : _data$status2[0]) === "sold" || (data === null || data === void 0 ? void 0 : (_data$status3 = data.status) === null || _data$status3 === void 0 ? void 0 : _data$status3[1]) === "sold") && !bothSold ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "compare-partial-sold-banner-container",
    className: "container pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:pb-8 mb-7 mt-4 md:mt-6 md:mb-0"
  }, /*#__PURE__*/React.createElement("div", {
    id: "compare-partial-sold-banner",
    className: "w-full bg-primary p-2 rounded  md:px-4 mt-4  mb:7"
  }, /*#__PURE__*/React.createElement("span", {
    id: "compare-partial-sold-text",
    className: "text-white font-bold text-sm"
  }, t("one_chosen_cars_sold", {
    ns: "web_common"
  })))))) : null), /*#__PURE__*/React.createElement("div", {
    id: "compare-sticky-title-row",
    ref: stickyRef,
    className: twMerge("bg-white py-4 sticky top-[60px] md:top-[60px] z-50 md:bg-gray-alice md:pt-6 md:pb-0", isComponentSticky ? 'md:bg-white md:pb-6 border-b border-solid border-gray-azureish' : '')
  }, /*#__PURE__*/React.createElement("div", {
    id: "compare-car-links",
    className: "container flex  md:max-w-[767px] xl:px-4"
  }, (data === null || data === void 0 ? void 0 : (_data$id2 = data.id) === null || _data$id2 === void 0 ? void 0 : _data$id2[0]) && /*#__PURE__*/React.createElement(Link, {
    id: "compare-car-link",
    to: createUrl("/cardetail/".concat(data === null || data === void 0 ? void 0 : (_data$id3 = data.id) === null || _data$id3 === void 0 ? void 0 : _data$id3[0])),
    className: "text-primary text-center text-sm font-bold underline w-1/2 line-clamp-1"
  }, (data === null || data === void 0 ? void 0 : (_data$status4 = data.status) === null || _data$status4 === void 0 ? void 0 : _data$status4[0]) !== "sold" ? data === null || data === void 0 ? void 0 : (_data$title2 = data.title) === null || _data$title2 === void 0 ? void 0 : _data$title2[0] : ""), (data === null || data === void 0 ? void 0 : (_data$status5 = data.status) === null || _data$status5 === void 0 ? void 0 : _data$status5[1]) !== "sold" && /*#__PURE__*/React.createElement(Link, {
    id: "compare-car-link-2",
    to: createUrl("/cardetail/".concat(data === null || data === void 0 ? void 0 : (_data$id4 = data.id) === null || _data$id4 === void 0 ? void 0 : _data$id4[1])),
    className: "text-primary text-center text-sm font-bold underline w-1/2 line-clamp-1"
  }, (data === null || data === void 0 ? void 0 : (_data$status6 = data.status) === null || _data$status6 === void 0 ? void 0 : _data$status6[1]) !== "sold" ? data === null || data === void 0 ? void 0 : (_data$title3 = data.title) === null || _data$title3 === void 0 ? void 0 : _data$title3[1] : ""))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "compare-images-section",
    className: "md:bg-gray-alice"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2 w-full md:max-w-[767px] md:m-auto md:p-4 rounded"
  }, data !== null && data !== void 0 && (_data$id5 = data.id) !== null && _data$id5 !== void 0 && _data$id5[0] && (data === null || data === void 0 ? void 0 : (_data$status7 = data.status) === null || _data$status7 === void 0 ? void 0 : _data$status7[0]) !== "sold" ? renderImage(data === null || data === void 0 ? void 0 : (_data$image = data.image) === null || _data$image === void 0 ? void 0 : _data$image[0], data === null || data === void 0 ? void 0 : (_data$id6 = data.id) === null || _data$id6 === void 0 ? void 0 : _data$id6[0], 0) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "compare-add-car-icon",
    className: "w-1/2 border border-dashed border-gray-azureish bg-white flex flex-col items-center justify-center rounded cursor-pointer h-[130px] md:h-[265px]",
    onClick: function onClick() {
      return handeAddCar();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add-2-rounded",
    width: 7,
    height: 7,
    variant: "primary"
  }), /*#__PURE__*/React.createElement("span", {
    id: "compare-add-car-text",
    className: "text-primary font-bold text-xs gap-1"
  }, t("add_car", {
    ns: "web_common"
  })))), data !== null && data !== void 0 && (_data$id7 = data.id) !== null && _data$id7 !== void 0 && _data$id7[1] && (data === null || data === void 0 ? void 0 : (_data$status8 = data.status) === null || _data$status8 === void 0 ? void 0 : _data$status8[1]) !== "sold" ? renderImage(data === null || data === void 0 ? void 0 : (_data$image2 = data.image) === null || _data$image2 === void 0 ? void 0 : _data$image2[1], data === null || data === void 0 ? void 0 : (_data$id8 = data.id) === null || _data$id8 === void 0 ? void 0 : _data$id8[1], 1) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "compare-add-car-icon-2",
    className: "w-1/2 border border-dashed border-gray-azureish bg-white flex flex-col items-center justify-center rounded cursor-pointer h-[130px] md:h-[265px]",
    onClick: function onClick() {
      return handeAddCar();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add-2-rounded",
    width: 7,
    height: 7,
    variant: "primary"
  }), /*#__PURE__*/React.createElement("span", {
    id: "compare-add-car-text-2",
    className: "text-primary font-bold text-xs gap-1"
  }, t("add_car", {
    ns: "web_common"
  })))))))), /*#__PURE__*/React.createElement("div", {
    id: "compare-tabs-wrapper",
    className: twMerge("w-full")
  }, !bothSold && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    tabs: tabs,
    enableScrollBehaviour: true,
    tabsTop: twMerge("top-[113px] md:top-[126px] md:bg-gray-alice", isTabsSticky ? 'md:bg-white shadow-card' : ''),
    ref: tabsSticky,
    tabScrollMarginTop: "scroll-mt-[170px] md:scroll-mt-[220px]",
    onTabClick: function onTabClick(id) {
      handleTabClick(id);
    }
  }))), isSticky && /*#__PURE__*/React.createElement("div", {
    id: "compare-reserve-bar",
    className: "fixed bottom-0 right-0 px-6 py-4 bg-white shadow-card rounder-lg w-full flex items-center gap-3 md:max-w-[735px] md:right-[50%] md:transform md:translate-x-1/2 md:rounded-t-lg"
  }, /*#__PURE__*/React.createElement("button", {
    id: "compare-action-btn",
    onClick: function onClick() {
      return handleReserveCar(0);
    },
    disabled: (data === null || data === void 0 ? void 0 : (_data$status9 = data.status) === null || _data$status9 === void 0 ? void 0 : _data$status9[0]) !== "active",
    className: "button-0 text-center bg-success rounded text-white font-bold px-4 py-3 border-0 outline-none hover:text-white w-1/2 disabled:bg-neutral-60 disabled:text-neutral-70 disabled:pointer-events-none"
  }, t("reserve", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    id: "compare-reserve-divider",
    className: "w-px h-6 bg-gray-azureish rounded"
  }), /*#__PURE__*/React.createElement("button", {
    id: "compare-action-btn-2",
    onClick: function onClick() {
      return handleReserveCar(1);
    },
    disabled: (data === null || data === void 0 ? void 0 : (_data$status0 = data.status) === null || _data$status0 === void 0 ? void 0 : _data$status0[1]) !== "active",
    className: "button-1 text-center bg-success rounded text-white font-bold px-4 py-3 border-0 outline-none hover:text-white w-1/2 disabled:bg-neutral-60 disabled:text-neutral-70 disabled:pointer-events-none"
  }, t("reserve", {
    ns: "web_common"
  }))))));
};
export default CarComparison;